/***********************************************
ICEMEDX - Developed By ICEMEDX, Inc.
Copyright 2018 ICEMEDX, Inc.
***********************************************/
import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpResponse, HttpHandler, HttpEvent } from '@angular/common/http';
import { Observable } from 'rxjs';
import 'rxjs/add/operator/do';
import { LoginService } from './login.service';

@Injectable()
export class LoginHttpInterceptor implements HttpInterceptor {

  constructor(private loginsvc: LoginService) { }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (request.headers.has('Authorization')) {
      const interceptedRequest = request.clone({ headers: request.headers });
      return next.handle(interceptedRequest);
    }

    let userInfo = this.loginsvc.GetSessionUserInfo();
    if (this.loginsvc.IsSignedIn(userInfo)) {
      const interceptedRequest = request.clone({
        headers: request.headers.set('Authorization', 'Bearer ' + this.loginsvc.GetAccessToken(userInfo)),
      });
      return next.handle(interceptedRequest);
    }
    return next.handle(request);
  }
}
